import { useMemo } from "react";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  nome?: string | null;
  status?: number | null;
  codigo?: string | null;
  localizacao?: string | null;
  centrocustoDropDown: { id: number; title: string }[];
  centrocusto?: number[] | null;
  onNome: (novoProjeto: string | null) => void;
  onStatusChange: (novoStatus: number | null) => void;
  onCodigoChange: (novoCodigo: string | null) => void;
  onLocalizacaoChange: (novaLocalizacao: string | null) => void;
  onCentroCustoChange: (novoCentroCusto: number[] | null) => void;
  onClear: () => void;
};

export const Header = ({
  nome,
  status,
  codigo,
  localizacao,
  centrocustoDropDown,
  centrocusto,
  onNome,
  onStatusChange,
  onCodigoChange,
  onLocalizacaoChange,
  onCentroCustoChange,
  onClear,
}: Props) => {

  const selectedCentroCusto = useMemo(() => {
    if (!centrocusto || centrocusto.length === 0) return null;
    return centrocustoDropDown.filter((x) => centrocusto.includes(x.id));
  }, [
    centrocusto,
    centrocustoDropDown,
  ]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense">
          <FormControl size="small" fullWidth>
            <InputLabel id="modulo-dashboard">Status</InputLabel>
            <Select
              labelId="modulo-dashboard"
              label="Status"
              value={status ?? ""}
              onChange={(e) => onStatusChange(Number(e.target.value))}>
              <MenuItem value={2}>Todos</MenuItem>
              <MenuItem value={1}>Ativos</MenuItem>
              <MenuItem value={0}>Inativo</MenuItem>
            </Select>
          </FormControl>

          <DefaultInput
            label="Pesquisar por Nome"
            name="search_by_projeto"
            value={nome ?? ""}
            onChangeValue={onNome}
          />

          <DefaultInput
            label="Pesquisar por Localização"
            name="search_by_localizacao"
            value={localizacao ?? ""}
            onChangeValue={onLocalizacaoChange}
          />

          <DefaultInput
            label="Pesquisar por Código"
            name="search_by_codigo"
            value={codigo ?? ""}
            onChangeValue={onCodigoChange}
          />

          <DefaultMultiAutocomplete
            label="Centro de Custo"
            value={selectedCentroCusto}
            options={centrocustoDropDown}
            getOptionLabel={(x) => x.title}
            getOptionKey={(x) => x.id}
            onChange={x => onCentroCustoChange(x ? x.map((item) => item.id) : null)}
          />
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClear}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
};
